import Image from 'next/image'
import codaraStripesUpperLarge from '@shared/assets/stripes/UpperLarge.png'
import codaraStripesUpperSmall from '@shared/assets/stripes/UpperSmall.png'
import codaraStripesLowerLarge from '@shared/assets/stripes/LowerLarge.png'
import codaraStripesLowerSmall from '@shared/assets/stripes/LowerSmall.png'

export default function CodaraStripes() {
  return (
    <>
      <div
        style={{
          pointerEvents: 'none',
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
        }}
      >
        <Image
          src={codaraStripesUpperLarge}
          alt='Codara upper large decorative stripe'
          width={300}
          height={24}
          style={{ width: 120, position: 'absolute', top: -40, left: -40 }}
          priority
        />
        <Image
          src={codaraStripesUpperSmall}
          alt='Codara upper small decorative stripe'
          width={300}
          height={24}
          style={{ width: 120, position: 'absolute', top: 0, left: -20 }}
          priority
        />
      </div>
      <div
        style={{
          pointerEvents: 'none',
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
        }}
      >
        <Image
          src={codaraStripesLowerLarge}
          alt='Codara lower large decorative stripe'
          width={300}
          height={24}
          style={{ width: 120, position: 'absolute', right: -45, bottom: 0 }}
          priority
        />
        <Image
          src={codaraStripesLowerSmall}
          alt='Codara lower small decorative stripe'
          width={300}
          height={24}
          style={{
            width: 120,
            position: 'absolute',
            right: -10,
            bottom: 0,
          }}
          priority
        />
      </div>
    </>
  )
}
